/*
import ImagePicker from 'react-native-image-picker';
export default ImagePicker;

*/
/*require('react-native-image-picker');*/

export default {
  showImagePicker: function() {
    return {didCancel:true};
  },
}

export function showImagePicker(opt, callback) {
	callback({didCancel:true})
    return {didCancel:true};
}